module.exports = __webpack_public_path__ + "static/media/60.78c2803f.png";